import React from 'react'
import styled, { css } from 'styled-components'
import WikiActionChip from './WikiActionChip'

const Callout = styled.div`
  border-radius: 6px;
  padding: 12px 14px;
  margin: 12px 0;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
  flex-wrap: wrap;

  ${({ severity }) => {
    if (severity === 'critical') {
      return css`
        background: #fef2f2;
        border: 1px solid #fecaca;
        border-left: 4px solid #b91c1c;
        color: #7f1d1d;
      `
    }
    if (severity === 'high') {
      return css`
        background: #fff7ed;
        border: 1px solid #fed7aa;
        border-left: 4px solid #c2410c;
        color: #7c2d12;
      `
    }
    return css`
      background: #fffbeb;
      border: 1px solid #fde68a;
      border-left: 4px solid #b45309;
      color: #78350f;
    `
  }}
`

const Body = styled.div`
  flex: 1;
  min-width: 220px;
`

const TitleLine = styled.div`
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 2px;

  &::before {
    content: '⚠';
    margin-right: 6px;
  }
`

const Detail = styled.div`
  font-size: 13px;
  line-height: 1.5;
`

const Actions = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
`

const WikiAnomalyCallout = ({ anomaly, actions = [] }) => (
  <Callout severity={anomaly.severity}>
    <Body>
      <TitleLine>{anomaly.title}</TitleLine>
      <Detail>{anomaly.detail}</Detail>
    </Body>
    {actions.length > 0 && (
      <Actions>
        {actions.map((a, idx) => (
          <WikiActionChip
            key={`${a.label}-${idx}`}
            Icon={a.Icon}
            label={a.label}
            href={a.href}
            variant={a.variant || (idx === 0 ? 'primary' : 'default')}
            title={a.title}
          />
        ))}
      </Actions>
    )}
  </Callout>
)

export default WikiAnomalyCallout
